var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavoriteActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1L10.0984 5.11181L14.6574 5.83688L11.3953 9.10319L12.1145 13.6631L8 11.57L3.8855 13.6631L4.60473 9.10319L1.3426 5.83688L5.90161 5.11181L8 1Z",
    fill: "#006564",
    stroke: "#006564",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoriteActive);
export default __webpack_public_path__ + "static/media/icon_favorite_active.e7d3b20eee07c996277e1920c982992e.svg";
export { ForwardRef as ReactComponent };